import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { TEAM, SITE } from "@/data/site";
import Sticker from "@/components/site/Sticker";

export default function About() {
  return (
    <div data-testid="about-page">
      {/* ── HERO ── */}
      <section className="border-b border-zinc-900 grid grid-cols-1 md:grid-cols-12">
        <div className="md:col-span-8 border-b md:border-b-0 md:border-r border-zinc-900 px-5 md:px-10 pt-12 pb-10 overflow-hidden">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF1111]">
            About the Agency
          </p>
          <h1
            className="font-display uppercase leading-[0.88] mt-4 break-words"
            style={{ fontSize: "clamp(2.4rem, 6vw, 7rem)" }}
          >
            BEHIND THE LABEL
          </h1>
          <div className="mt-6 max-w-3xl font-grotesk text-base md:text-lg lg:text-xl text-zinc-700 leading-relaxed">
            <p>
              Hot Sauce Media started in Pune with a shared passion for content, design, and building things that stand out. What began as a creative vision has grown into a creative media agency helping creators, founders, startups, and businesses build stronger digital presence through content, storytelling, and social media.
            </p>
          </div>
        </div>
        <div className="md:col-span-4 p-8 md:p-10 flex items-center justify-center bg-zinc-50 min-h-[200px]">
          <Sticker size={180} />
        </div>
      </section>

      {/* ── AGENCY STORY ── */}
      {/* <section className="border-b border-zinc-900">
        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr]">
          <div className="border-b lg:border-b-0 lg:border-r border-zinc-900 p-6 md:p-10 lg:p-12">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FF1111]">
              Agency story
            </p>
            <h2 className="font-display uppercase text-3xl md:text-5xl lg:text-6xl leading-[0.88] mt-4">
              CREATE. CAPTIVATE.
              <br />
              <span className="text-[#FF1111]">CONVERT.</span>
            </h2>
          </div>
          <div className="p-6 md:p-10 lg:p-12 bg-zinc-50">
            <p className="font-grotesk text-base md:text-lg text-zinc-700 leading-relaxed">
              We keep our process simple: understand the idea, build thoughtfully, and refine until it feels right.
            </p>
          </div>
        </div>
      </section> */}

      {/* ── TEAM ── */}
      <section className="border-b border-zinc-900">
        <div className="px-5 md:px-10 py-10 flex flex-col sm:flex-row sm:items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF1111]">
              The team
            </p>
            <h2 className="font-display uppercase text-3xl md:text-5xl lg:text-6xl leading-[0.88] mt-4">
              THE MINDS BEHIND 
              <br />
              <span className="text-[#FF1111]">HOT SAUCE.</span>
            </h2>
          </div>
          <p className="font-grotesk text-sm text-zinc-600 max-w-xs">
            Strategy, content, design, and execution all working together to build ideas that stand out.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-zinc-900 border-t border-zinc-900">
          {TEAM.map((t) => (
            <div
              key={t.name}
              className="bg-white p-7 md:p-10 lg:p-12 transition-all duration-200 hover:bg-[#FF1111] hover:text-white group"
            >
              <p className="font-mono text-xs uppercase tracking-[0.2em] opacity-60">
                {t.city}
              </p>
              <p className="font-display uppercase text-3xl md:text-4xl lg:text-5xl leading-[0.9] mt-5">
                {t.name}
              </p>
              <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] opacity-70 group-hover:opacity-100">
                {t.role}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="border-b border-zinc-900 grid grid-cols-1 md:grid-cols-12">
        <div className="md:col-span-8 p-7 md:p-12 border-b md:border-b-0 md:border-r border-zinc-900">
          <h3 className="font-display uppercase text-3xl md:text-5xl lg:text-6xl leading-[0.88]">
            ready to 
            <br />
            <span className="text-[#FF1111]">start something?</span>
          </h3>
        </div>
        <div className="md:col-span-4 p-7 md:p-12 flex flex-col justify-between gap-6">
          <p className="font-grotesk text-zinc-700 text-sm md:text-base leading-relaxed">
            Whether it's a new idea, a launch, or your next chapter, we're here to help bring it to life.
          </p>
          <Link
            to="/contact"
            data-testid="about-cta"
            className="inline-flex items-center justify-between gap-4 bg-[#FF1111] text-white px-6 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-black transition-all duration-200 min-h-[44px]"
          >
            start a project <ArrowUpRight size={16} />
          </Link>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">
            @{SITE.instagram} • {SITE.phoneDisplay}
          </p>
        </div>
      </section>
    </div>
  );
}
